import React, { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { useTriggerSectionIsViewedGaEvent } from 'core/hooks/useTriggerSectionIsViewedGaEvent';
import { selectSiteUrl } from 'core/selectors/app';

import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';

import { useGetCategories } from 'core/modules/Navigation/NavCategories/hooks/useGetCategories';

import orgConfig from 'org/configs/org.config';
import config from './configs';

import { triggerExploreCategoriesIsViewed } from './actions';

import './ExploreCategories.scss';

function ExploreCategories() {
  const dispatch = useDispatch();
  const siteUrl = useSelector(selectSiteUrl);
  const exploreCategoriesRef = useRef();
  const { categories } = useGetCategories();

  const { categoriesToShow, getTitle } = config;
  const { earnType } = orgConfig;
  const title = getTitle(earnType);

  const categoriesToRender = categories.slice(0, categoriesToShow);

  const dispatchTriggerSectionIsViewed = () => dispatch(triggerExploreCategoriesIsViewed());
  useTriggerSectionIsViewedGaEvent(exploreCategoriesRef, dispatchTriggerSectionIsViewed);

  if (isEmpty(categoriesToRender)) {
    return null;
  }

  return (
    <div className="mn_exploreCategories" ref={exploreCategoriesRef}>
      <ContentWrap>
        <SectionTitle title={title} />
        <ul>
          {categoriesToRender.map(category => (
            <li key={category.id}>
              <a
                title={`Visit the ${category.name} page`}
                href={`${siteUrl}/${category.searchFriendlyName}/bc_${category.id}___.htm`}
              >
                <i className="mn_categoryIcon" aria-hidden="true" id={category.id} />
                <span className="mn_categoryName">{category.name}</span>
              </a>
            </li>
          ))}
        </ul>
      </ContentWrap>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><ExploreCategories {...props} /></ComponentErrorBoundary>;
